/**
 * Unidade `hours` das séries (ex.: "Horas Extras (horas)", "Horas de Faltas" do Conector NUCONT).
 *
 * O VALOR continua em horas DECIMAIS (1h30 = 1.5): fórmulas, indicadores e somas trabalham com
 * o número. Só a EXIBIÇÃO vira `H:MM`. Quem soma (total de tabela, acumulado) soma o decimal e
 * formata no fim — nunca soma texto.
 */
export const HOURS_UNIT = "hours";

export const isHoursUnit = (unit) => unit === HOURS_UNIT;

const thousands = (integer) =>
    String(integer).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

/**
 * Horas decimais em `H:MM`.
 *
 * - minutos arredondados (`Math.round(frac * 60)`); 60 minutos sobem para a hora;
 * - horas sem limite (449.8 → "449:48"), com milhar pt-BR (1234.5 → "1.234:30");
 * - negativo com o sinal na frente (-1.5 → "-1:30"); o que arredonda para zero sai sem sinal;
 * - `null`, `undefined`, vazio ou não numérico → "" (o mesmo que o filtro `number` do Angular,
 *   usado pelas outras unidades no `FormatUnits`).
 *
 * @param {Number|String} value horas decimais
 * @returns {String}
 */
export const formatHours = (value) => {
    if (value === null || value === undefined || value === "") return "";

    const number = Number(value);
    if (!Number.isFinite(number)) return "";

    const absolute = Math.abs(number);
    let hours = Math.floor(absolute);
    let minutes = Math.round((absolute - hours) * 60);

    if (minutes === 60) {
        hours += 1;
        minutes = 0;
    }

    const sign = number < 0 && (hours > 0 || minutes > 0) ? "-" : "";

    return `${sign}${thousands(hours)}:${String(minutes).padStart(2, "0")}`;
};
